module.exports = __webpack_public_path__ + "9f3cc4e1a61a29650942184dcf9055bd.png";